import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[validateOnBlur]'
})
export class ValidateOnBlurDirective {
  @Input() validateFormControl;

  constructor() {}

  @HostListener('focus', ['$event.target'])
  onFocus(target) {
    if (target.attributes.id.value == 'username' || target.attributes.id.value == 'password') {
      if (this.validateFormControl.hasOwnProperty('controls'))
        this.validateFormControl.controls.forEach(function (control) {
          control.updateValueAndValidity();
        });
      else this.validateFormControl.updateValueAndValidity();
    }
  }

  @HostListener('focusout', ['$event.target'])
  onFocusout(target) {
    if (target.attributes.id.value == 'username' || target.attributes.id.value == 'password') {
      if (this.validateFormControl.hasOwnProperty('controls'))
        this.validateFormControl.controls.forEach(function (control) {
          control.updateValueAndValidity();
        });
      else this.validateFormControl.updateValueAndValidity();
    }
  }

  @HostListener('keydown', ['$event.target'])
  onKeydown(target) {
    if (target.attributes.id.value == 'username' || target.attributes.id.value == 'password') {
      if (this.validateFormControl.hasOwnProperty('controls'))
        this.validateFormControl.controls.forEach(function (control) {
          control.updateValueAndValidity();
        });
      else this.validateFormControl.updateValueAndValidity();
    }
  }
}
